module.exports = __webpack_public_path__ + "static/img/zzzs.da1431f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/zzzs.jpg
// module id = +f5h
// module chunks = 0